import { render } from "./LayoutFull.vue?vue&type=template&id=01958634&ts=true"
import script from "./LayoutFull.vue?vue&type=script&lang=ts"
export * from "./LayoutFull.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__